import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { notification, Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/users/usersController";
import moment from "moment";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { formatProjectDate } from "../../../controllers/common";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  {
    togglePopUp();
    setIsLoading(false);
  }

  const [isLoading, setIsLoading] = useState(false);
  // const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD') || '');
  // const [todayTime, setTodayTime] = useState('21:31:00');
  // const [yesterdayDate, setYesterdayDate] = useState(`${moment().subtract(1,'days').format('YYYY-MM-DD')}`);
  // const [yesterdayTime, setYesterdayTime] = useState('21:30:00');
  const [todayDate, setTodayDate] = useState('');
  const [todayTime, setTodayTime] = useState('');
  const [yesterdayDate, setYesterdayDate] = useState('');
  const [yesterdayTime, setYesterdayTime] = useState('');
  const handleDateTimeChange = (e)=>{
    const {name, value} = e.target;
    if(name === 'valid_date'){
      setYesterdayDate(value)
    } else if(name === 'valid_time'){
      setYesterdayTime(value)
    } else if(name === 'expire_date'){
      setTodayDate(value)
    } else if(name === 'expire_time'){
      setTodayTime(value)
    }
  }
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const option = {
        isExport : true,
        sort : { _id : -1 },
        condition : { 
          ...(formData.get('users_type') && {users_type : formData.get('users_type')}),
          ...(formData.get('users_name') && {users_name : { $regex: formData.get('users_name'), $options: "i" }}),
          ...(formData.get('last_name') && {last_name : { $regex: formData.get('last_name'), $options: "i" }}),
          ...(formData.get('users_mobile') && {users_mobile : parseInt(formData.get('users_mobile'))}),
          ...(formData.get('users_email') && {users_email : { $regex: formData.get('users_email'), $options: "i" }}),
          ...(formData.get('area') && {area : { $regex: formData.get('area'), $options: "i" }}),

          ...(formData.get('store_name') && {store_name : { $regex: formData.get('store_name'), $options: "i" }}),
          ...(formData.get('pos_number') && {pos_number : parseInt(formData.get('pos_number'))}),

          ...(formData.get('bind_person_name') && {bind_person_name : { $regex: formData.get('bind_person_name'), $options: "i" }}),
          ...(formData.get('bind_person_mobile') && {bind_person_mobile : parseInt(formData.get('bind_person_mobile'))}),
          ...(formData.get('bind_user_type') && {bind_user_type : formData.get('bind_user_type')}),
          ...(formData.get('status') && {status : formData.get('status')}),
          
          ...(formData.get('availableArabianPoints') && {availableArabianPoints : {$lte : parseFloat(formData.get('availableArabianPoints'))}}),

          // ...(yesterdayDate && { createdAt : {$gte : `${yesterdayDate} ${yesterdayTime}`} }),
          // ...(todayDate && { createdAt : {$lte : `${todayDate} ${todayTime}`} }),
          ...((yesterdayDate || todayDate) && {
            createdAt: {
              ...(yesterdayDate && {
                $gte: `${yesterdayDate} ${yesterdayTime || '00:00'}`
              }),
              ...(todayDate && {
                $lte: `${todayDate} ${todayTime || '23:59'}`
              }),
            }
          }),

         },
         select : {
          ...(
            formData.get('select_users_id') ||
            formData.get('select_users_type') ||
            formData.get('select_users_name') ||
            formData.get('select_last_name') ||
            formData.get('select_users_email') ||
            formData.get('select_users_mobile') ||
            formData.get('select_store_name') ||
            formData.get('select_bind_person_mobile') ||
            formData.get('select_bind_person_name') ||
            formData.get('select_bind_user_type') ||
            formData.get('select_pos_number') ||
            formData.get('select_area') ||
            formData.get('select_totalArabianPoints') ||
            formData.get('select_availableArabianPoints') ||
            formData.get('select_commission_percentage') ||
            formData.get('select_platform') ||
            formData.get('select_version') ||
            formData.get('select_version_2') ||
            formData.get('select_pos_serial_id') ||
            formData.get('select_pos_serial_id_2') ||
            formData.get('select_status') ||
            formData.get('select_contract_given_by') ||
            formData.get('select_due_amount') ||
            formData.get('select_createdAt') ?({
              ...(formData.get('select_users_id')?{users_id : true}:null),
              ...(formData.get('select_users_type')?{users_type : true}:null),
              ...(formData.get('select_users_name')?{users_name : true}:null),
              ...(formData.get('select_last_name')?{last_name : true}:null),
              ...(formData.get('select_users_email')?{users_email : true}:null),
              ...(formData.get('select_users_mobile')?{users_mobile : true}:null),
              ...(formData.get('select_area')?{area : true}:null),
              ...(formData.get('select_totalArabianPoints')?{totalArabianPoints : true}:null),
              ...(formData.get('select_availableArabianPoints')?{availableArabianPoints : true}:null),
              ...(formData.get('select_commission_percentage')?{commission_percentage : true}:null),
              ...(formData.get('select_store_name')?{store_name : true}:null),
              ...(formData.get('select_bind_person_mobile')?{bind_person_mobile : true}:null),
              ...(formData.get('select_bind_person_name')?{bind_person_name : true}:null),
              ...(formData.get('select_bind_user_type')?{bind_user_type : true}:null),
              ...(formData.get('select_pos_number')?{pos_number : true}:null),
              ...(formData.get('select_status')?{status : true}:null),
              ...(formData.get('select_createdAt')?{createdAt : true}:null),
              ...(formData.get('select_platform')?{platform : true}:null),
              ...(formData.get('select_version')?{version : true}:null),
              ...(formData.get('select_version_2')?{version_2 : true}:null),
              ...(formData.get('select_pos_serial_id')?{pos_serial_id : true}:null),
              ...(formData.get('select_pos_serial_id_2')?{pos_serial_id_2 : true}:null),
              ...(formData.get('select_sim_serial_no')?{sim_serial_no : true}:null),
              ...(formData.get('select_sim_serial_no_2')?{sim_serial_no_2 : true}:null),
              ...(formData.get('select_contract_given_by')?{contract_given_by : true}:null),
              ...(formData.get('select_due_amount')?{due_amount : true}:null)
            }):({
              _id : false,
              __v : false,
              updated_by : false,
              updated_ip : false,
              created_ip : false,
              created_by : false,
              country_code : false,
              password : false,
              token : false
            })
          )
         }
      }
      // console.log('option',option);
      const res = await list(option);
      if(res.status === true){
        let modifiedData = res?.result.map((items, index) => ({
          "Sl. No"            : index + 1,
          "User's Type"       : items?.users_type,
          "First Name"        : items?.users_name,
          "Last Name"         : items?.last_name,
          "Mobile No."        : items?.users_mobile,
          "Email Id"          : items?.users_email,
          "POS No."           : items?.pos_number,
          "Store"             : items?.store_name,
          "Area"              : items?.area,
          'Total QR-Points'    : items?.totalArabianPoints,
          'Avl. QR-Points'     : items?.availableArabianPoints,
          "Bind With Person"  : items?.bind_person_name,
          "Due Amount"        : items?.due_amount ?? 0,
          "Commission"        : items?.commission_percentage,
          "Status"            : items?.status,
          "POS serial No"     : items?.pos_serial_id,
          "Second POS serial No"     : items?.pos_serial_id_2,
          "Sim serial No"            : items?.sim_serial_no,
          "Second Sim serial No"     : items?.sim_serial_no_2,
          "Contract Given By" : items?.contract_given_by || "--",
          ...(items?.last_login && {"Last Login"        : moment(formatProjectDate(items?.last_login)).format('DD-MM-YYYY HH:mm')}),
          "Platform"        : items?.platform || "-",
          "Version"        : items?.version || "-",
          "Version Device 2"        : items?.version_2 || "-",
          "Created Date"      : moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY HH:mm'),
        }));
        if(modifiedData?.length > 0){
          await exportToExcel(modifiedData);
        }else {
          notification.open({
            message: "Oops!",
            description: `No record found.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
        handleCancel();
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Users");
      XLSX.writeFile(workbook, `Crown-king-Users-${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }

  };

  const [checkedData, setCheckedData] = useState({});
  const handleChecked = (e) =>{
    try {
      const {name} = e.target;
      setCheckedData((prev)=>({
        ...prev,
        [name] : prev[name] === "Y" ? "N" : "Y",
      }))
    } catch (error) {
      
    }
  }
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export users's 
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_type" className="all_lable_for_vendor_dashbaord" > User's type : </label>
                      <select name="users_type" id="users_type" className="form-control categories_select_tg_enter_product">
                        <option value='' selected disabled>Choose user's type</option>
                        <option value='Freelancer'>Freelancer</option>
                        <option value='Sales Person'>Sales Person</option>
                        <option value='Retailer'>Retailer</option>
                        <option value='Promoter'>Promoter</option>
                        <option value='Users'>Users</option>
                        <option value='Tester'>Tester</option>
                      </select>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="bind_user_type" className="all_lable_for_vendor_dashbaord" > Bind with user's type : </label>
                      <select name="bind_user_type" id="bind_user_type" className="form-control categories_select_tg_enter_product">
                        <option value='' selected disabled>Choose user's type</option>
                        <option value='Freelancer'>Freelancer</option>
                        <option value='Sales Person'>Sales Person</option>
                        <option value='Retailer'>Retailer</option>
                        <option value='Promoter'>Promoter</option>
                        <option value='Users'>Users</option>
                        <option value='Tester'>Tester</option>
                      </select>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_name" className="all_lable_for_vendor_dashbaord" > User's name : </label>
                      <input type="text" name="users_name" id="users_name" placeholder="user's name" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="last_name" className="all_lable_for_vendor_dashbaord" > User's last name : </label>
                      <input type="text" name="last_name" id="last_name" placeholder="user's last name" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="bind_person_name" className="all_lable_for_vendor_dashbaord" > Bind with user's name : </label>
                      <input type="text" name="bind_person_name" id="bind_person_name" placeholder="Bind with user's name" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="bind_person_mobile" className="all_lable_for_vendor_dashbaord" > Bind with user's mobile : </label>
                      <input type="text" name="bind_person_mobile" id="bind_person_mobile" placeholder="Bind with user's name" className="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_mobile" className="all_lable_for_vendor_dashbaord" > User's mobile : </label>
                      <input type="number" name="users_mobile" id="users_mobile" placeholder="User's mobile" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_email" className="all_lable_for_vendor_dashbaord" > User's email : </label>
                      <input type="text" name="users_email" id="users_email" placeholder="User's email" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                      <label for="area" className="all_lable_for_vendor_dashbaord" > Area : </label>
                      <input type="text" name="area" id="area" placeholder="Area" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="pos_number" className="all_lable_for_vendor_dashbaord" >POS number : </label>
                      <input type="number" name="pos_number" id="pos_number" placeholder="POS number" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label htmlFor="status" className="all_lable_for_vendor_dashbaord" > Users's Status : </label>
                      <select name="status" id="status" className="form-control categories_select_tg_enter_product">
                        <option value='A' selected >Active</option>
                        <option value='I' >Inactive</option>
                        <option value='D'>Deleted</option>
                        <option value='B'>Blocked</option>
                        <option value=''>All</option>
                      </select>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="store_name" className="all_lable_for_vendor_dashbaord" > Store's Name : </label>
                      <input type="text" name="store_name" id="store_name" placeholder="Store's name " class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="availableArabianPoints" className="all_lable_for_vendor_dashbaord" > Avl. Points : </label>
                      <input type="number" name="availableArabianPoints" id="availableArabianPoints" placeholder="Avl. Points Less than" class="form-control categories_select_tg_enter_product" />
                      {/* <select name="availableArabianPoints" className="form-control categories_select_tg_enter_product">
                        <option value={''}>Select Avl. Points</option>
                        <option value={100} >{`Less than 100 `}</option>
                        <option value={200} >{`Less than  200`}</option>
                        <option value={500} >{`Less than 500`}</option>
                        <option value={1000} >{`Less than 1000`}</option>
                        <option value={1000} >{`Less than 3000`}</option>
                        <option value={1000} >{`Less than 5000`}</option>
                      </select> */}
                    </div>

                  

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label
                        for="select_title"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        {" "}
                        Date specific (If any) :
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="valid_date"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        From :
                      </label>
                      <input
                        type="date"
                        name="valid_date"
                        id="valid_date"
                        value={yesterdayDate}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="valid_time"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        Time :
                      </label>
                      <input
                        type="time"
                        name="valid_time"
                        id="valid_time"
                        value={yesterdayTime}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="expire_date"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        To :
                      </label>
                      <input
                        type="date"
                        name="expire_date"
                        id="expire_date"
                        value={todayDate}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                      <label
                        htmlFor="expire_time"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        Time :
                      </label>
                      <input
                        type="time"
                        name="expire_time"
                        id="expire_time"
                        value={todayTime}
                        onChange={handleDateTimeChange}
                        className="form-control categories_select_tg_enter_product"
                      />
                    </div>


                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="select_name" className="all_lable_for_vendor_dashbaord" > Export fields (If any) : </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_id" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_id" id="select_users_id" className="form-check-input" 
                        checked={checkedData?.select_users_id === "Y" ? true : false} onClick={handleChecked} /> User's seq. Id 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_type" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_type" id="select_users_type" className="form-check-input"
                        checked={checkedData?.select_users_type !== "Y" ? true : false} onClick={handleChecked} /> User's type 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_name" id="select_users_name" className="form-check-input"
                        checked={checkedData?.select_users_name !== "Y" ? true : false} onClick={handleChecked} /> First Name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_last_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_last_name" id="select_last_name" className="form-check-input"
                        checked={checkedData?.select_last_name !== "Y" ? true : false} onClick={handleChecked} /> last Name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_mobile" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_mobile" id="select_users_mobile" className="form-check-input"
                        checked={checkedData?.select_users_mobile !== "Y" ? true : false} onClick={handleChecked} /> User's mobile 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_email" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_email" id="select_users_email" className="form-check-input"
                        checked={checkedData?.select_users_email !== "Y" ? true : false} onClick={handleChecked} /> User's email 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_area" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_area" id="select_area" className="form-check-input"
                        checked={checkedData?.select_area !== "Y" ? true : false} onClick={handleChecked} /> Area 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_store_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_store_name" id="select_store_name" className="form-check-input"
                        checked={checkedData?.select_store_name !== "Y" ? true : false} onClick={handleChecked} /> Store's Name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_bind_person_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_bind_person_name" id="select_bind_person_name" className="form-check-input"
                        checked={checkedData?.select_bind_person_name !== "Y" ? true : false} onClick={handleChecked} /> Bind with user' name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_bind_person_mobile" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_bind_person_mobile" id="select_bind_person_mobile" className="form-check-input"
                        checked={checkedData?.select_bind_person_mobile === "Y" ? true : false} onClick={handleChecked} /> Bind with user' mobile 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_bind_user_type" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_bind_user_type" id="select_bind_user_type" className="form-check-input"
                        checked={checkedData?.select_bind_user_type === "Y" ? true : false} onClick={handleChecked} /> Bind user's type 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_pos_number" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_pos_number" id="select_pos_number" className="form-check-input"
                        checked={checkedData?.select_pos_number !== "Y" ? true : false} onClick={handleChecked} /> POS number 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_availableArabianPoints" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_availableArabianPoints" id="select_availableArabianPoints" className="form-check-input"
                        checked={checkedData?.select_availableArabianPoints !== "Y" ? true : false} onClick={handleChecked} /> Available QR-Points 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_commission_percentage" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_commission_percentage" id="select_commission_percentage" className="form-check-input"
                        checked={checkedData?.select_commission_percentage !== "Y" ? true : false} onClick={handleChecked} /> Commission percentage 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_totalArabianPoints" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_totalArabianPoints" id="select_totalArabianPoints" className="form-check-input"
                        checked={checkedData?.select_totalArabianPoints !== "Y" ? true : false} onClick={handleChecked} /> Total QR-Points 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_pos_serial_id" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_pos_serial_id" id="select_pos_serial_id" className="form-check-input"
                        checked={checkedData?.select_pos_serial_id !== "Y" ? true : false} onClick={handleChecked} /> Serial No. 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_pos_serial_id_2" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_pos_serial_id_2" id="select_pos_serial_id_2" className="form-check-input"
                        checked={checkedData?.select_pos_serial_id_2 !== "Y" ? true : false} onClick={handleChecked} /> Second Serial No. 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_sim_serial_no" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_sim_serial_no" id="select_sim_serial_no" className="form-check-input"
                        checked={checkedData?.select_sim_serial_no !== "Y" ? true : false} onClick={handleChecked} /> Sim Serial No. 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_sim_serial_no_2" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_sim_serial_no_2" id="select_sim_serial_no_2" className="form-check-input"
                        checked={checkedData?.select_sim_serial_no_2 !== "Y" ? true : false} onClick={handleChecked} /> Second Sim Serial No. 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_platform" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_platform" id="select_platform" className="form-check-input"
                        checked={checkedData?.select_platform === "Y" ? true : false} onClick={handleChecked} /> Platform 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_version" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_version" id="select_version" className="form-check-input"
                        checked={checkedData?.select_version !== "Y" ? true : false} onClick={handleChecked} /> Version
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_version_2" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_version_2" id="select_version_2" className="form-check-input"
                        checked={checkedData?.select_version_2 !== "Y" ? true : false} onClick={handleChecked} /> Version Device 2
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_status" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_status" id="select_status" className="form-check-input"
                        checked={checkedData?.select_status !== "Y" ? true : false} onClick={handleChecked} /> Status 
                      </label>
                    </div>
                    
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_createdAt" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_createdAt" id="select_createdAt" className="form-check-input"
                        checked={checkedData?.select_createdAt !== "Y" ? true : false} onClick={handleChecked} /> Created At 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_contract_given_by" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_contract_given_by" id="select_contract_given_by" className="form-check-input"
                        checked={checkedData?.select_contract_given_by !== "Y" ? true : false} onClick={handleChecked} /> Contract given by 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_due_amount" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_due_amount" id="select_due_amount" className="form-check-input"
                        checked={checkedData?.select_due_amount !== "Y" ? true : false} onClick={handleChecked} /> Due Amount 
                      </label>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
